import { render, staticRenderFns } from "./addJoinWay.vue?vue&type=template&id=294dc262&scoped=true"
import script from "./addJoinWay.vue?vue&type=script&lang=js"
export * from "./addJoinWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294dc262",
  null
  
)

export default component.exports